import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { BrManageContentButton } from '@bloomreach/react-sdk'

import ReactPlayerLoader from '@brightcove/react-player-loader'

import {
  styleMap,
  getLinkUrl,
  getColor,
  isScreenSmall,
  BRIGHTCOVE_VIDEO_PLAYER_ID,
  BRIGHTCOVE_VIDEO_BLOG_PLAYER_ID,
  getMargins,
} from '../../utility'

import { Title, Subtitle, Link2, LinkList } from '..'
import '../../../components/EmailSubscriptionCenter/Modal'

import './banner.css'
import { encodeForURL } from '../../../global/formatters/string-formatter'

export function BannerVideo({
  page,
  parameters,
  styles,
  blurb,
  height,
  renderIcons,
  bannerType,
  setStyles,
  setIsPlaying,
  isPlaying,
  hasVisualMedia,
}) {
  const wrapper = useRef()

  const onSuccess = (success) => {
    success.ref.on('play', onPlay)
    success.ref.on('pause', onPause)
    success.ref.on('ended', onEnded)
    //delaying running this to give the page time to load so all elements
    //can be correctly targeted
    const timer = setTimeout(() => {
      handleControlbarMenus()
    }, 1000)
    return () => clearTimeout(timer)
  }

  const onPlay = () => {
    if (parameters.derived?.isList) {
      setStyles({
        ...styles,
        ...styleMap[parameters.style || 'None'],
      })

      setIsPlaying(true)
    }
    otherVidoeStop()
  }

  const onPause = (event) => {
    // Prevents video from minimizing when seeking
    if (event.target.player.readyState() !== 4) {
      return
    }

    if (parameters.derived?.isList) {
      setStyles({
        ...styles,
        ...styleMap[
          parameters.style
            ? parameters.derived?.isList
              ? parameters.style + 'InList'
              : parameters.style
            : 'None'
        ],
      })

      setIsPlaying(false)
    }
  }

  const otherVidoeStop = () => {
    if (wrapper.current) {
      const videoList = document?.querySelectorAll('.video-player')
      const mediaId = hasVisualMedia?.includes('|')
        ? hasVisualMedia?.split('|')[0].trim()
        : hasVisualMedia
      if (videoList && videoList.length > 0) {
        videoList.forEach((video) => {
          const videoElement = video.querySelector('video-js')
          if (
            videoElement &&
            videoElement.player &&
            videoElement.dataset?.videoId !== mediaId
          ) {
            videoElement.player.pause()
            videoElement.player.src(videoElement.player.currentSrc())
            videoElement.player.autoplay(false)
          }
        })
      }
    }
  }

  const onEnded = (e) => {
    e.target.player.src(e.target.player.currentSrc())
  }

  const handleControlbarMenus = () => {
    let playbackMenu = undefined
    let playbackButton = undefined
    let qualityMenu = undefined
    let qualityButton = undefined
    let controlBar = undefined
    let videoPlayer = undefined

    const videoList = document.getElementsByTagName('video-js')
    for (const singleVideo of videoList) {
      videoPlayer = singleVideo
      for (const videoChild of singleVideo.children) {
        if (videoChild.className === 'vjs-control-bar') {
          controlBar = videoChild
          for (const controlChild of videoChild.children) {
            if (controlChild.innerText.includes('Playback Rate')) {
              playbackButton = controlChild
              for (const menuChild of controlChild.children) {
                if (menuChild.className === 'vjs-menu') {
                  playbackMenu = menuChild
                }
              }
            }

            if (controlChild.innerText.includes('Quality Levels')) {
              qualityButton = controlChild
              for (const menuChild of controlChild.children) {
                if (menuChild.className === 'vjs-menu') {
                  qualityMenu = menuChild
                }
              }
            }
          }
        }
      }
    }

    //adding and removing events for popup menus
    controlBar?.addEventListener('mouseenter', () => {
      playbackMenu?.classList.remove('vjs-menu-popup')
      qualityMenu?.classList.remove('vjs-menu-popup')
    })

    playbackButton?.addEventListener('mouseenter', () => {
      playbackMenu?.classList.add('vjs-menu-popup')
      qualityMenu?.classList.remove('vjs-menu-popup')
      qualityMenu?.classList.remove('vjs-lock-showing')
    })

    qualityButton?.addEventListener('mouseenter', () => {
      playbackMenu?.classList.remove('vjs-menu-popup')
      qualityMenu?.classList.add('vjs-menu-popup')
      qualityMenu?.classList.remove('vjs-lock-showing')
    })

    qualityButton?.addEventListener('click', () => {
      qualityMenu?.classList.remove('vjs-lock-showing')
    })

    playbackMenu?.addEventListener('mouseleave', () => {
      playbackMenu?.classList.remove('vjs-menu-popup')
    })

    qualityMenu?.addEventListener('mouseleave', () => {
      qualityMenu?.classList.remove('vjs-menu-popup')
    })

    videoPlayer?.addEventListener('mouseleave', () => {
      qualityMenu?.classList.remove('vjs-menu-popup')
      playbackMenu?.classList.remove('vjs-menu-popup')
    })
  }

  const playInfo = {}

  if (blurb?.videoId) {
    if (blurb?.videoId.includes('|')) {
      playInfo.videoId = blurb.videoId.split('|')[0].trim()
      playInfo.accountId = blurb.videoId.split('|')[1]
        ? blurb.videoId.split('|')[1].trim()
        : window.BRIGHTCOVE_PLAYER_ACCOUNT_ID
    } else {
      playInfo.accountId = window.BRIGHTCOVE_PLAYER_ACCOUNT_ID
      playInfo.videoId = blurb.videoId
    }
  }

  return (
    <div
      id={blurb.title?.replace(/[^A-Za-z]/g, '').toLowerCase()}
      className={`Banner2 u-posRelative ${
        bannerType ? `bannerType-${bannerType}` : ''
      } ${
        parameters.derived?.isCallout
          ? 'u-marginBottom8gu u-decoBorderLight u-decoBorderResetBottom'
          : getMargins(parameters.marginTop, parameters.marginBottom)
      }`}
      style={{ minHeight: blurb.imageUrl || blurb.videoId ? height : null }}
    >
      <BrManageContentButton content={blurb.document} />
      <div
        className={`u-flex u-flexWrap ${
          styles.outerBackground ? styles.backgroundColor : ''
        }`}
      >
        {(blurb.imageUrl ||
          (!styles.outerBackground && parameters.backgroundColor)) && (
          <div
            id="banner-background-image"
            className={`u-posAbsolute ${
              parameters.derived?.isCallout ? 'u-sm-posRelative' : ''
            } ${styles.imageSize || ''} ${
              (!blurb.imageUrl || parameters.style === 'Icon') &&
              parameters.backgroundColor
                ? styles.backgroundColor
                : ''
            } ${styles.backgroundSize || ''}`}
            style={{
              backgroundImage:
                blurb.imageUrl && parameters.style !== 'Icon'
                  ? 'url("' + encodeForURL(blurb.imageUrl) + '")'
                  : null,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              top: 0,
              left: styles.leftPosition,
              right: styles.rightPosition,
              minHeight: isScreenSmall() ? height : '',
              height:
                blurb.imageUrl && parameters.style !== 'Icon' ? '100%' : height,
            }}
            role="img"
            aria-label={blurb.imageDescription || 'banner'}
          />
        )}
        {(blurb.title ||
          blurb.subtitle ||
          blurb.html ||
          blurb.link?.url ||
          blurb.link?.href ||
          blurb.videoId ||
          (blurb.imageUrl && parameters.style === 'Icon')) && (
          <div
            className={`outerContainer u-posRelative u-sizeFull ${
              !parameters.derived?.isList || isPlaying ? styles.outerSize : ''
            } ${
              (parameters.position === 'Left' ||
                parameters.position === 'Right') &&
              blurb.imageUrl &&
              !parameters.derived?.isCallout
                ? 'u-sm-bgColorShaded'
                : ''
            } ${parameters.derived?.isQuote ? 'u-sm-transformUp50' : ''}`}
            style={{
              top: 0,
              bottom: 0,
              zIndex: 1,
              minHeight:
                (blurb.imageUrl ||
                  parameters.backgroundColor ||
                  blurb.videoId) &&
                (!parameters.derived?.isList || isPlaying) &&
                (!parameters.derived?.isCallout || !isScreenSmall())
                  ? height
                  : 'auto',
            }}
          >
            {blurb.videoId && (
              <div
                className={`Video u-posAbsolute u-sm-posRelative ${styles.videoSize}`}
                style={{
                  left: styles.leftPosition,
                  right: styles.rightPosition,
                  height: height,
                }}
              >
                <div
                  ref={wrapper}
                  className="video-player u-flex u-flexJustifyEnd"
                  style={{ width: '100%', height: '100%' }}
                >
                  <ReactPlayerLoader
                    accountId={playInfo?.accountId}
                    videoId={playInfo?.videoId} // e.g. '6259022897001'
                    // options={{ autoplay: 'play' }}
                    onSuccess={onSuccess}
                    playerId={
                      playInfo?.accountId ===
                      window.BRIGHTCOVE_PLAYER_BLOG_ACCOUNT_ID
                        ? BRIGHTCOVE_VIDEO_BLOG_PLAYER_ID
                        : BRIGHTCOVE_VIDEO_PLAYER_ID
                    }
                    attrs={{
                      'data-analytics':
                        blurb.title
                          ?.replaceAll('.', '')
                          .replaceAll(' ', '-')
                          .toLowerCase() + '-video',
                    }}
                  />
                </div>
              </div>
            )}
            <div
              className={`u-flex u-flexCol ${styles.position || ''} ${
                styles.alignment || ''
              }`}
              style={{ height: '100%' }}
            >
              {blurb.imageUrl && parameters.style === 'Icon' && (
                <img src={encodeForURL(blurb.imageUrl)} />
              )}
              <div className={`u-flex u-sizeFull ${styles.position2 || ''}`}>
                <div
                  className={`u-flex u-flexCol ${styles.alignment || ''} ${
                    (blurb.imageUrl &&
                      (styles.textBackgroundColor || styles.backgroundColor)) ||
                    ''
                  } ${
                    (parameters.position === 'Left' ||
                      parameters.position === 'Right') &&
                    blurb.imageUrl &&
                    !parameters.derived?.isCallout
                      ? 'u-sm-bgColorTransparent'
                      : ''
                  } ${styles.innerSize || ''} ${styles.paddingVert || ''} ${
                    styles.paddingHoriz || ''
                  } ${styles.borderColor || ''}`}
                >
                  {blurb.subtitle &&
                    (parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout) && (
                      <Subtitle
                        text={blurb.subtitle}
                        textColor={styles.secondaryColor}
                        textSize={styles.subtitleSize}
                        lineColor={getColor(blurb.keys)}
                        mode={`${
                          parameters.derived?.isQuote
                            ? 'quote'
                            : getColor(blurb.keys)
                              ? 'line-left'
                              : 'line'
                        }`}
                      />
                    )}
                  {(blurb.itemType || blurb.time) &&
                    !(
                      parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout
                    ) && (
                      <div className="u-flex u-flexAlignItemsCenter u-marginBottom4gu">
                        {renderIcons()}
                      </div>
                    )}
                  {blurb.title && (
                    <Title
                      text={blurb.title}
                      textColor={styles.textColor}
                      textAlign={styles.textAlign}
                      textSize={
                        parameters.position === 'Top Angled'
                          ? 'u-textSizeMsrp5 u-sm-textSizeMsrp4 u-md-textSizeMsrp4'
                          : (blurb.itemType || blurb.time) &&
                              !parameters.derived?.isCallout
                            ? 'u-textSizeMsrp4'
                            : parameters.derived?.isQuote
                              ? 'u-textSizeMsrp2'
                              : null
                      }
                      lineColor={getColor(blurb.keys)}
                      mode={
                        parameters.derived?.isCallout
                          ? 'medium-large'
                          : parameters.style !== 'Subheading Above' &&
                              !blurb.time &&
                              getColor(blurb.keys)
                            ? 'large-line-left'
                            : 'large'
                      }
                    />
                  )}
                  {blurb.publicationDate && (
                    <Subtitle
                      text={new Date(blurb.publicationDate).toLocaleDateString(
                        'en-us',
                        { year: 'numeric', month: 'long', day: 'numeric' }
                      )}
                      textColor={styles.textColor}
                      mode="small-bold"
                    />
                  )}

                  {blurb.subtitle &&
                    !(
                      parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout
                    ) && (
                      <Subtitle
                        text={blurb.subtitle}
                        textColor={styles.secondaryColor}
                        textAlign={styles.textAlign}
                        textSize={
                          blurb.publicationDate
                            ? 'u-textSizeMsr u-textOpen'
                            : styles.subtitleSize
                        }
                        mode="medium"
                      />
                    )}
                  {blurb.html && (
                    <div
                      className={`Content ${styles.contentColor || ''} ${
                        styles.textAlign || ''
                      }`}
                      dangerouslySetInnerHTML={{
                        __html: page.rewriteLinks(blurb.html),
                      }}
                    />
                  )}
                  {(blurb.itemType || blurb.time) &&
                    (parameters.derived?.isSubheadingAbove ||
                      parameters.derived?.isCallout) && (
                      <div className="u-flex u-flexAlignItemsCenter u-marginTop4gu">
                        {renderIcons()}
                      </div>
                    )}
                  {blurb?.subscriptionCenter?.active && (
                    <email-subscription-modal
                      data-use-unlabeled-button="true"
                      data-subscription-name={blurb.subscriptionCenter.name}
                      tertiary
                    ></email-subscription-modal>
                  )}
                  <div className={`u-flex u-flexAlignItemsCenter`}>
                    {blurb.link?.text && (
                      <div
                        className={`${
                          parameters.position === 'Top Angled'
                            ? 'u-marginTop6gu'
                            : 'u-marginTop2gu'
                        }`}
                      >
                        <Link2
                          url={getLinkUrl(blurb.link)}
                          text={blurb.link.text}
                          icon={blurb.link.icon}
                          arrow={styles.arrow}
                          className={`Link ${styles.buttonColor} ${styles.hover}`}
                          textClasses={`u-textSecondary u-textKernLoose`}
                        />
                      </div>
                    )}
                    {blurb.linkList && blurb.linkList.length > 0 && (
                      <LinkList
                        linkList={blurb.linkList}
                        buttonClass={`${styles.buttonColor} ${styles.buttonClass}`}
                        buttonColor={styles.buttonColor}
                        spacingClass="u-marginLeft5gu"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

BannerVideo.propTypes = {
  page: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  styles: PropTypes.object,
  blurb: PropTypes.object,
  height: PropTypes.number,
  renderIcons: PropTypes.func,
  bannerType: PropTypes.string,
  setStyles: PropTypes.func,
  setIsPlaying: PropTypes.func,
  isPlaying: PropTypes.bool,
}
